/* eslint-disable no-unused-vars */
import React, { useEffect, useRef, useState } from "react";
import { Modal, Form, DatePicker, Space } from "antd";
import { Table, Button, Input, Select, Row, Col } from "antd";
import {
  CloseOutlined,
  FormOutlined,
  PlusCircleOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import { CountryDropdown, RegionDropdown } from "react-country-region-selector";
import { useSelector } from "react-redux";
import Axios from "../../../api/Axios";
import { useForm, useWatch } from "antd/es/form/Form";
const { Option } = Select;
const AddLocation = ({
  CreateSuccessfull,
  CreateFailed,
  onCancel,
  visible,
}) => {
  // const myDayjsDate = dayjs(props.record.start_date, "YYYY-MM-DD");
  // console.log(myDayjsDate);
  const [selectedCountry, setSelectedCountry] = useState("");
  const [resources, setResources] = useState([{ key: "", value: "" }]);

  const [selectedState, setSelectedState] = useState("");
  const userInfo = useSelector((state) => state.user);
  const formRef = useRef();
  const handleCancel = () => {
    formRef.current.resetFields();
    onCancel();
  };

  function getCookie(name) {
    const cookies = document.cookie.split("; ");
    for (let i = 0; i < cookies.length; i++) {
      const [cookieName, cookieValue] = cookies[i].split("=");
      if (cookieName === name) {
        return cookieValue;
      }
    }
    return null;
  }
  const csrfToken = getCookie("csrftoken");

  const onFinish = async (values) => {
    //console.log(values);
    const additionalValues = {
      status: true,
      organization: userInfo.data.organization.id,
      Resources: values?.dynamic_fields?.length || null,
    };
    const newValues = { ...values, ...additionalValues };
    console.log(newValues);

    try {
      const res = await Axios.post("/locationcreate/", newValues, {
        headers: {
          "X-CSRFToken": csrfToken,
        },
      });
      //console.log(res);
      handleCancel();
      CreateSuccessfull("Created");
    } catch (err) {
      //console.log(err);
      CreateFailed("Created", err);
    }
  };
  const [form] = Form.useForm();
  const typeValue = useWatch("type", form);
  return (
    <Modal
      // title="My Modal"
      open={visible}
      onCancel={handleCancel}
      footer={null}
      title={<p className="modal-heading">ADD LOCATION</p>}
      centered
      width={850}
    >
      <Form
        name="complex-form"
        onFinish={onFinish}
        layout="vertical"
        ref={formRef}
        form={form}
        labelCol={{
          span: 25,
        }}
        wrapperCol={{
          span: 80,
        }}
        style={{
          width: "100%",
        }}
      >
        <div className="group1" style={{ padding: "0rem" }}>
          <div className="antd-test-client" style={{ marginTop: "2rem" }}>
            <Row gutter={20} style={{ marginLeft: "2rem" }}>
              <Col xs={24} sm={12} md={10} lg={8} xl={8}>
                <Form.Item
                  label={<p className="my-form-lables">Location name</p>}
                >
                  <Form.Item
                    name="name"
                    rules={[{ required: true, message: "name is required" }]}
                  >
                    <Input
                      placeholder="location name"
                      name="application"
                      className="my-form-input-antd-test"
                    />
                  </Form.Item>
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={10} lg={16} xl={16}>
                <Form.Item label={<p className="my-form-lables">Address</p>}>
                  <Form.Item
                    name="address"
                    rules={[{ required: true, message: "address is required" }]}
                  >
                    <Input
                      placeholder="Address"
                      name="address"
                      className="my-form-input-antd-test"
                    />
                  </Form.Item>
                </Form.Item>
              </Col>
            </Row>
          </div>
          <div className="antd-test-client">
            <Row gutter={20} style={{ marginLeft: "2rem" }}>
              <Col xs={24} sm={12} md={8} lg={7} xl={7}>
                <Form.Item label={<p className="my-form-lables">Country</p>}>
                  <Input.Group compact>
                    <Form.Item
                      name="country"
                      noStyle
                      initialValue={"United States"}
                      rules={[
                        { required: true, message: "country is required" },
                      ]}
                    >
                      <CountryDropdown
                        value={selectedCountry}
                        onChange={(val) => setSelectedCountry(val)}
                        placeholder="Select County"
                        defaultOptionLabel="United States"
                        className="my-form-input-antd-test"
                        style={{ height: "3.5rem" }}
                      />
                    </Form.Item>
                  </Input.Group>
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={8} lg={7} xl={7}>
                <Form.Item label={<p className="my-form-lables">State</p>}>
                  <Input.Group compact>
                    <Form.Item
                      name="state"
                      noStyle
                      rules={[{ required: true, message: "State is required" }]}
                    >
                      <RegionDropdown
                        country={
                          selectedCountry === ""
                            ? "United States"
                            : selectedCountry
                        }
                        value={selectedState}
                        onChange={(val) => setSelectedState(val)}
                        className="my-form-input-antd-test"
                        style={{ height: "3.5rem" }}
                      />
                    </Form.Item>
                  </Input.Group>
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={5} lg={5} xl={5}>
                <Form.Item
                  label={<p className="my-form-lables">ZIP/Postal Code</p>}
                >
                  <Form.Item
                    name="zipcode"
                    noStyle
                    rules={[
                      {
                        pattern:
                          selectedCountry === "United Kingdom"
                            ? /^[0-9a-zA-Z]*$/
                            : /^[0-9]*$/,
                        message:
                          selectedCountry === "United Kingdom"
                            ? "Please enter valid characters only"
                            : "Please enter numbers only",
                      },
                      {
                        min:
                          selectedCountry === "United States" ||
                          selectedCountry === "India" ||
                          selectedCountry === "United Kingdom" ||
                          selectedCountry === ""
                            ? 5
                            : undefined,
                        max:
                          selectedCountry === ""
                            ? 5
                            : selectedCountry === "United States"
                            ? 5
                            : selectedCountry === "India"
                            ? 6
                            : selectedCountry === "United Kingdom"
                            ? 7
                            : undefined,
                        message: "Invalid postal code",
                      },
                      { required: true, message: "Code is required" },
                    ]}
                  >
                    <Input
                      className="my-form-input-antd-test"
                      placeholder="Enter zip code"
                    />
                  </Form.Item>
                </Form.Item>
              </Col>

              <Col xs={24} sm={12} md={8} lg={5} xl={5}>
                <Form.Item label={<p className="my-form-lables">Type</p>}>
                  <Form.Item
                    name="type"
                    noStyle
                    rules={[{ required: true, message: "Type is required" }]}
                  >
                    <Select
                      className="my-form-input-antd-test"
                      placeholder="Select type"
                      name="type"
                    >
                      <Select.Option value="Training">Training</Select.Option>
                      <Select.Option value="Office">Office</Select.Option>
                    </Select>
                  </Form.Item>
                </Form.Item>
              </Col>
            </Row>
            {typeValue === "Training" && (
              <Row gutter={20} style={{ marginLeft: "3rem", width: "100%" }}>
                <Form.Item
                  label={<p className="my-form-lables">Resources</p>}
                  style={{ width: "100%" }}
                >
                  {/* {resources.map((item, index) => (
                    <div
                      key={index}
                      style={{
                        display: "flex",
                        marginBottom: "1rem",
                        alignItems: "center",
                        width: "100%",
                        gap: "8px",
                      }}
                    >
                      <Input
                        placeholder="Key"
                        value={item.key}
                        onChange={(e) => {
                          const newItems = [...resources];
                          newItems[index].key = e.target.value;
                          setResources(newItems);
                        }}
                        style={{ width: "40%" }}
                      />
                      <Input
                        placeholder="Value"
                        value={item.value}
                        onChange={(e) => {
                          const newItems = [...resources];
                          newItems[index].value = e.target.value;
                          setResources(newItems);
                        }}
                        style={{ width: "60%" }}
                      />
                      <div style={{ display: "flex", gap: "8px" }}>
                        <DeleteOutlined
                          onClick={() => {
                            const newItems = [...resources];
                            newItems.splice(index, 1);
                            setResources(newItems);
                          }}
                          style={{
                            color: "red",
                            cursor: "pointer",
                            fontSize: "16px",
                          }}
                        />
                        {index === resources.length - 1 && (
                          <PlusCircleOutlined
                            onClick={() =>
                              setResources([
                                ...resources,
                                { key: "", value: "" },
                              ])
                            }
                            style={{
                              color: "#1890ff",
                              cursor: "pointer",
                              fontSize: "16px",
                            }}
                          />
                        )}
                      </div>
                    </div>
                  ))} */}
                  <Form.List
                    name="dynamic_fields"
                    style={{ padding: "0px", margin: "0px" }}
                  >
                    {(fields, { add, remove }) => (
                      <>
                        {fields.map(({ key, name, ...restField }, index) => (
                          <div
                            key={key}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",

                              width: "100%",
                            }}
                          >
                            <Form.Item
                              {...restField}
                              name={[name, "field_name"]}
                              style={{ width: "40%", marginBottom: "2rem" }}
                              rules={[
                                ({ getFieldValue }) => ({
                                  validator(_, value) {
                                    const other = getFieldValue([
                                      "resources",
                                      name,
                                      "field_value",
                                    ]);
                                    if (!value && other) {
                                      return Promise.reject(
                                        new Error("Key is required")
                                      );
                                    }
                                    return Promise.resolve();
                                  },
                                }),
                              ]}
                            >
                              <Input placeholder="Key" />
                            </Form.Item>

                            <Form.Item
                              {...restField}
                              name={[name, "field_value"]}
                              style={{ width: "60%", marginBottom: "2rem" }}
                              rules={[
                                ({ getFieldValue }) => ({
                                  validator(_, value) {
                                    const other = getFieldValue([
                                      "resources",
                                      name,
                                      "field_name",
                                    ]);
                                    if (!value && other) {
                                      return Promise.reject(
                                        new Error("Value is required")
                                      );
                                    }
                                    return Promise.resolve();
                                  },
                                }),
                              ]}
                            >
                              <Input placeholder="Value" />
                            </Form.Item>

                            <DeleteOutlined
                              onClick={() => remove(name)}
                              style={{
                                color: "red",
                                cursor: "pointer",
                                fontSize: "16px",
                                marginBottom: "2rem",
                              }}
                            />
                            {index === fields.length - 1 && (
                              <PlusCircleOutlined
                                onClick={() => add()}
                                style={{
                                  color: "#1890ff",
                                  cursor: "pointer",
                                  fontSize: "16px",
                                  marginBottom: "2rem",
                                }}
                              />
                            )}
                          </div>
                        ))}
                        {fields.length === 0 && (
                          <Button
                            type="dashed"
                            onClick={() => add()}
                            icon={<PlusCircleOutlined />}
                          >
                            Add Resource
                          </Button>
                        )}
                      </>
                    )}
                  </Form.List>
                </Form.Item>
              </Row>
            )}
          </div>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            height: "2rem",
            marginTop: "1rem",
            marginBottom: "1rem",
          }}
        >
          <Form.Item style={{ marginRight: "1rem" }}>
            <Button key="back" onClick={handleCancel}>
              <CloseOutlined />
              Cancel
            </Button>
          </Form.Item>
          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              style={{
                background: "#f58029",
              }}
              className="save-update-btn"
            >
              Save
              <FormOutlined />
            </Button>
          </Form.Item>
        </div>
      </Form>
    </Modal>
  );
};

export default AddLocation;
